<template>
  <delete-dialog
    :title="'opdrachten.dialoog.titel'"
    :content="'opdrachten.dialoog.content'"
    :delete-object="deleteObject"
    :value="value"
    @on-deleted="verwijder"
    @annuleer="annuleer"
  />
</template>

<script lang="ts">
import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import WizardButtonGroup from '@/components/button/WizardButtonGroup.vue';
import TextButton from '@/components/button/TextButton.vue';
import {OpdrachtClass} from '@/domain/interface/opdracht/OpdrachtClass';
import DeleteDialog from '@/components/dialog/DeleteDialog.vue';
import {DeleteDialogObject} from '@/domain/interface/DeleteDialogObject';

@Component({
  components: {
    DeleteDialog,
    TextButton,
    WizardButtonGroup,
  },
})
export default class OpdrachtDeleteDialog extends Vue {
  @Prop(Boolean) value!: boolean;
  @Prop(Object) readonly opdracht!: OpdrachtClass;
  @Provide() deleteObject!: DeleteDialogObject;

  created() {
    this.deleteObject = new DeleteDialogObject();
    this.deleteObject.naam = this.opdracht.naam;
    this.deleteObject.links = this.opdracht.links;
  }

  verwijder() {
    this.$emit('on-deleted');
  }

  annuleer() {
    this.$emit('close');
  }
}
</script>
